import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import OtpInput from "react-otp-input";

import { OTP, Auth } from "services/action";

import { Page } from "ui/components";

import otp from "../../../assets/otp.png";

const OTPScreen = ({ location }) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [seconds, setSeconds] = React.useState(30);
  const [token, setToken] = React.useState("");
  const [otpPhone, setOtpPhone] = React.useState("");

  const $resend = async (e) => {
    const payload = {
      phone: location?.state?.phone,
    };
    const req = await Dispatch(OTP.$resend(payload));

    if (req?.message === "success") {
      setOtpPhone(req?.data?.replace("62", "0"));
    }
  };

  const handleResend = () => {
    setSeconds(30);
    $resend();
  };

  const $handleSubmit = async (e) => {
    const payload = {
      token: token,
      app: "driver",
    };

    if (location?.state?.type === "reset") {
      History.push({
        pathname: "/reset-password",
        state: {
          token: token,
        },
      });
    } else {
      const x = await Dispatch(Auth.$verify(payload));
      if (x?.message === "success") {
        History.replace("/");
      }
    }
  };

  React.useEffect(() => {
    setOtpPhone(location?.state?.phone_otp);
  }, []);

  React.useEffect(() => {
    let interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  });

  return (
    <Page className="bg-container-image position-relative align-items-center">
      <div className="mt-3 mb-3">
        <img src={otp} alt="" className="img-fluid" height={30} />
      </div>

      <div className="mb-4">
        <div style={{ fontSize: 20, fontWeight: 700, textAlign: "left" }}>
          Masukkan Kode OTP
        </div>
        <div className="mt-2 mb-2" style={{ textAlign: "left" }}>
          Kode verifikasi akan kami kirimkan melalui <b>Missed Call</b>.
          Pastikan perangkat Anda sedang aktif agar kami hubungi.
        </div>
        <div className="mt-2 mb-2" style={{ textAlign: "left" }}>
          Silakan masukkan <b>4 angka terakhir</b> dari nomor yang menelepon
          Anda.
        </div>

        <div className="d-flex align-items-center ">
          <OtpInput
            value={otpPhone}
            numInputs={otpPhone?.length}
            inputStyle="border-1 border-light w-100 rounded fs-20 text-white h-40"
            isDisabled
            disabledStyle="bg-primary text-white"
          />
          <span>-</span>
          <OtpInput
            value={token}
            numInputs={4}
            inputStyle="border-1 border-primary w-100 rounded fs-20 h-40"
            focusStyle="border-primary border-2"
            separator={<span>&nbsp;</span>}
            onChange={(e) => setToken(e)}
            shouldAutoFocus
            isInputNum
            hasErrored={StateForm?.errors?.token}
          />
        </div>

        <Button
          type="button"
          variant="primary"
          className="w-100 mt-3 p-2"
          onClick={$handleSubmit}
        >
          Verifikasi
        </Button>
      </div>

      <div
        style={{ textAlign: "center" }}
        className="px-3 position-absolute bottom-0 start-50 translate-middle-x w-100 mb-3"
      >
        <small>Belum menerima kode OTP?</small>
        <br />
        {seconds === 0 ? (
          <div onClick={handleResend}>
            <small className="text-primary fw-semibold">
              Kirim ulang kode otp
            </small>
          </div>
        ) : (
          <small className="text-primary fw-semibold">
            {" "}
            Kirim ulang mohon tunggu {seconds < 10
              ? `0${seconds}`
              : seconds}{" "}
            detik
          </small>
        )}
      </div>
    </Page>
  );
};

export default OTPScreen;
